export default __webpack_public_path__ + "static/media/cademia-logo-nb.d9f354d0.png";